// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"73cac36f","504":"7adddb70","815":"79dca3a3"}[chunkId] + ".css";
};